import { ThermometerOffIcon } from './ThermometerOffIcon';

/**
 * author: Colton Wiscombe
 * id BF73A396-DB1C-46BC-8078-3CF0D7E0277F
 * name thermometer-off
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-off.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const TemperatureOffIcon = ThermometerOffIcon;
export default TemperatureOffIcon